import './less/default.less'
import map from 'ubsspadvisor-staticfile'
import htmlComponent from 'htmlcomponent'

htmlComponent.setStaticLoader(map)
htmlComponent.query(document)
htmlComponent.observe()

document.addEventListener("DOMContentLoaded", function() {

  htmlcomponent.query(document);

		/* expand navigation */
    let toggleMobile = document.querySelector('button[data-menu-toggle="is-active"')
		toggleMobile.addEventListener("click", function (e) {
			toggleMobile.classList.toggle("is-active");
			document.querySelector('header').classList.toggle("is-active");
			document.querySelector('body').classList.toggle("navigation-active");
		});

		//remove javascript class
		document.classList.add("is-ready");

});
